import { useEffect } from "react"
import styled from "styled-components"

const Message = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: #f9fafb;
  color: #1f2937;
  font-size: 18px;
  text-align: center;
`

const DispatchAssignmentPage = () => {
  useEffect(() => {
    const { origin, pathname, search, hash } = window.location
    const normalizedPath = pathname.replace(/\/{2,}/g, "/")
    const canonicalPath = normalizedPath.endsWith("/")
      ? normalizedPath
      : `${normalizedPath}/`
    const targetUrl = `${origin}${canonicalPath}${search}${hash}`

    if (targetUrl !== window.location.href) {
      window.location.replace(targetUrl)
    } else {
      // Fallback: if we're somehow still here, redirect to the printable template root.
      window.location.replace(`${origin}/dispatch-public/`)
    }
  }, [])

  return <Message>Redirecting to dispatch assignment…</Message>
}

export default DispatchAssignmentPage
